import './featuresSpecs.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/FeaturesSpecs/index.js